<template>
  <div v-if="carrier === 'ktj' || carrier === 'ty'">
    倉庫完成打包後，一件宅配包裹加收300元台幣，
    以貨到付款方式收取。
  </div>
  <div v-else>
    集運重量1~5公斤加收90元台幣，5公斤以上加收110元台幣，
    下單時與集運費用一同收取。
  </div>
</template>
<script>
export default {
  props: {
    carrier: String,
  }
}
</script>
